import React from 'react';
import CommingSoon from '../../Shared/CommingSoon/CommingSoon';
import './Vaccination.css'

const Vaccination = () => {
    return (
        <div>
            <CommingSoon></CommingSoon>
        </div>
    );
};

export default Vaccination;